import { AddIcon } from "@/assets/icons";
import { Button, Tooltip } from "@altimateai/lego";
import { useState } from "react";
import TagFormDialog from "./TagFormDialog";
import { isOwner } from "@/services/auth";
const CreateTag = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsDialogOpen(true);
  };

  const handleClose = () => {
    setIsDialogOpen(false);
  };

  if (!isOwner()) {
    return null;
  }

  return (
    <>
      <Tooltip title="Create New Tag">
        <Button onClick={handleClick}>
          <AddIcon className="h-4 w-4 mr-2" />
          Create Tags
        </Button>
      </Tooltip>
      {isDialogOpen && <TagFormDialog onClose={handleClose} />}
    </>
  );
};

export default CreateTag;
